import "core-js/modules/es6.array.filter";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/**
 * Filter results - Replaces current filter value
 *
 * Will trigger new search
 *
 * @param name String field name to filter on
 * @param value String field value to filter on
 * @param type String (Optional) type of filter to apply
 */

export default function setFilter(name, value) {
  var _console;

  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "all"; // eslint-disable-next-line no-console

  if (this.debug) (_console = console).log.apply(_console, ["Search UI: Action", "setFilter"].concat(Array.prototype.slice.call(arguments)));
  var filters = this.state.filters;
  filters = filters.filter(function (filter) {
    return filter.field !== name || filter.type !== type;
  });

  this._updateSearchResults({
    current: 1,
    filters: [].concat(_toConsumableArray(filters), [{
      field: name,
      values: [value],
      type: type
    }])
  });
}